var exports = {
  "kL": "AvatarWithPresence.module__container___cUwtY3",
  "_V": "AvatarWithPresence.module__containerSpeaking___cUwtY3",
  "V5": "AvatarWithPresence.module__voiceIndicatorIcon___cUwtY3",
};

module.exports = exports;
